import FaqItem from './faq-item'
import { FaqContainer, HR } from './faq-styles'
import data from '../../pages/faq-page/faq-data.json'

type SelectedNumber = {
  selectedNum: number
}

const FaqContent = ({ selectedNum }: SelectedNumber) => {
  return (
    <FaqContainer>
      <FaqItem
        data-testid={'faq-item'}
        title={data[selectedNum].section_heading}
        qAndAs={data[selectedNum].questions}
      />
      <HR />
    </FaqContainer>
  )
}

export default FaqContent
